module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Thin.ae097ba8.eot";